import React from 'react';
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from 'react-circular-progressbar';

interface IScoreProps {
  score: number;
}

const ScoreIndicator: React.FC<IScoreProps> = (props: IScoreProps) => {
  const { score } = props;
  return (
    <div className='bulk-score-container'>
      <div className='circular-progress-div'>
        <CircularProgressbarWithChildren
          value={score}
          styles={buildStyles({
            strokeLinecap: 'round',
            pathTransitionDuration: 0.5,
            pathColor: '#4361EE',
            trailColor: '#4A4C51',
          })}
        >
          <div className='progress-words'>
            <h3>{score > 0 ? score : '-'}</h3>
            <p>Record Count</p>
          </div>
        </CircularProgressbarWithChildren>
      </div>
      <div className='score-bottom-div'>
        <p>Score</p>
        <h3>{score > 0 ? score : '-'}</h3>
      </div>
    </div>
  );
};

export default ScoreIndicator;
